import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

// The Auth/PMB/Reff APIs now require the `jwt` auth cookie on every protected
// request. Angular's HttpClient does not send cookies cross-origin unless
// withCredentials is set on the request, and each service in this app calls a
// different port (a different origin in dev), so this has to be set globally
// rather than per call site.
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone({ withCredentials: true }));
  }
}
